import React, { ReactNode } from 'react';

export interface AccountSettingsSectionProps {
  title: string;
  additionalHeaderChild?: ReactNode;
  children: ReactNode;
}

export const AccountSettingsSection = ({ title, additionalHeaderChild, children }: AccountSettingsSectionProps) => (
  <div className='flex flex-col border-bw03 border-[1px] bg-surface-primary-bw-00 rounded-xl px-[32px] pb-[12px] pt-[24px] w-full bg-bw01 shadow-widgetCard'>
    <div className='flex flex-row justify-between'>
      <p className='text-bw08 text-[24px] font-metricRMedium '>{title}</p>
      {additionalHeaderChild}
    </div>
    {children}
  </div>
);
